import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import {
  IOsaExecucaoProgramaTrabalhoQuestaoModel,
  IOsaExecucaoProgramaTrabalhoQuestaoIncidentalCausaModel,
  IOsaExecucaoProgramaTrabalhoQuestaoIncidentalConsequenciaModel,
  IOsaExecucaoProgramaTrabalhoQuestaoIncidentalControleModel,
  IOsaExecucaoProgramaTrabalhoQuestaoIncidentalTecnicaAuditoriaModel,
  IOsaExecucaoProgramaTrabalhoQuestaoIncidentalProcedModel,
  IOsaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoModel
} from "./../../../../../models/osa-execucao-programa-trabalho.model";
import { OsaExecucaoProgramaTrabalhoService } from "./../../../../../services/osa-execucao-programa-trabalho.service";
import Swal from "sweetalert2";
import { AuthService } from "./../../../../../services/auth.service";
import { BaseFormComponent } from "../../../../../shared/components/base-form/base-form.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { ITecnicaAuditoriaModel } from "../../../../../models/tecnica-auditoria.model";
import { IProcedimentoAuditoriaModel } from "../../../../../models/procedimento-auditoria.model";
import { ProcedimentoAuditoriaService } from "./../../../../../services/procedimento-auditoria.service";
import { TecnicaAuditoriaService } from "./../../../../../services/tecnica-auditoria.service";
import { IQuestaoModel } from "../../../../../models/questao.model";
import { ETipoTesteQuestaoIncidental, ETipoTesteQuestaoIncidentalDescricao } from "../../../../../models/enum/tipo-teste-questao-incidental.enum";
import { IAmostraModel } from "../../../../../models/amostra.model";
import { AmostraService } from "../../../../../services/amostra.service";
import { OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoIncidSelecionarComponent } from "../osa-execucao-aba-folha-teste-programa-trabalho-questao-incid-selecionar/osa-execucao-aba-folha-teste-programa-trabalho-questao-incid-selecionar.component";

@Component({
  selector: 'app-osa-execucao-aba-folha-teste-programa-trabalho-questao-incid',
  templateUrl: './osa-execucao-aba-folha-teste-programa-trabalho-questao-incid.component.html',
  styleUrls: ['./osa-execucao-aba-folha-teste-programa-trabalho-questao-incid.component.scss']
})

export class OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoIncidComponent extends BaseFormComponent implements OnInit {

  @ViewChild("tabelaRiscoPaginator", { static: true })
  tabelaRiscoPaginator: MatPaginator;
  @ViewChild("tabelaRiscoSort", { static: true })
  tabelaRiscoSort: MatSort;

  @ViewChild("tabelaCausaPaginator", { static: true })
  tabelaCausaPaginator: MatPaginator;
  @ViewChild("tabelaCausaSort", { static: true })
  tabelaCausaSort: MatSort;

  @ViewChild("tabelaConsequenciaPaginator", { static: true })
  tabelaConsequenciaPaginator: MatPaginator;
  @ViewChild("tabelaConsequenciaSort", { static: true })
  tabelaConsequenciaSort: MatSort;

  @ViewChild("tabelaControlePaginator", { static: true })
  tabelaControlePaginator: MatPaginator;
  @ViewChild("tabelaControleSort", { static: true })
  tabelaControleSort: MatSort;

  @ViewChild("tabelaTecnicaAuditoriaPaginator", { static: true })
  tabelaTecnicaAuditoriaPaginator: MatPaginator;
  @ViewChild("tabelaTecnicaAuditoriaSort", { static: true })
  tabelaTecnicaAuditoriaSort: MatSort;

  @ViewChild("tabelaProcedPaginator", { static: true })
  tabelaProcedPaginator: MatPaginator;
  @ViewChild("tabelaProcedSort", { static: true })
  tabelaProcedSort: MatSort;

  public model = this.createModel();

  public dataSourceRisco = new MatTableDataSource<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoModel>([]);
  public riscoDigitado: string = "";

  public dataSourceCausa = new MatTableDataSource<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalCausaModel>([]);
  public causaDigitada: string = "";

  public dataSourceConsequencia = new MatTableDataSource<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalConsequenciaModel>([]);
  public consequenciaDigitada: string = "";

  public dataSourceControle = new MatTableDataSource<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalControleModel>([]);
  public controleDigitado: string = "";

  public dataSourceTecnicaAuditoria = new MatTableDataSource<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalTecnicaAuditoriaModel>([]);
  public tecnicaAuditoriaSelecionada: ITecnicaAuditoriaModel = {} as ITecnicaAuditoriaModel;

  public dataSourceProced = new MatTableDataSource<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalProcedModel>([]);
  public procedSelecionado: IProcedimentoAuditoriaModel = {} as IProcedimentoAuditoriaModel;
  public procedDigitado: string = "";

  public tituloModal = "";
  public visualizar = false;
  public alterar = false;
  public id: number = 0;

  public unidadeGestoraId: number = 0;
  public planejamentoId: number = 0;
  public questaoPlanejamentoId: number = 0;

  public enumTipoTesteQuestaoIncidental = ETipoTesteQuestaoIncidental;
  public tiposTesteQuestaoIncidental: { text: string, value: number }[] = [];

  public questaoOrigem: IOsaExecucaoProgramaTrabalhoQuestaoModel | null = null;
  public modoReuso: boolean = false;
  public amostras: IAmostraModel[] = [];
  public bloqueado: boolean = true;   // ← controla se os campos ficam bloqueados até a decisão via lupa
  public questaoOrigemId: number | null = null;

  // ← Crit 15 (HU reuso com edição): na seleção de questão existente a nova cópia preserva
  // Identificador/Descrição/Critérios/Fontes/Atividade da origem, mas Técnicas, Riscos, Causas,
  // Consequências, Controles, Tipo dos Testes, Amostra e Procedimentos são editáveis.
  // Mantido por compatibilidade; não bloqueia mais a edição (sempre false em modoReuso).
  public somenteLeituraReuso: boolean = false;

  constructor(
    public route: ActivatedRoute,
    public toastr: ToastrService,
    public router: Router,
    public localeService: BsLocaleService,
    public matDialog: MatDialog,
    public osaExecucaoProgramaTrabalhoService: OsaExecucaoProgramaTrabalhoService,
    public tecnicaAuditoriaService: TecnicaAuditoriaService,
    public procedimentoAuditoriaService: ProcedimentoAuditoriaService,
    public amostraService: AmostraService,
    public authService: AuthService,
    private dialogRef: MatDialogRef<OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoIncidComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    super(route, toastr, router, localeService, matDialog);

    this.id = data?.id;
    this.visualizar = data?.visualizar;
    this.alterar = data?.alterar;
    this.tituloModal = data?.titulo;

    this.unidadeGestoraId = data?.unidadeGestoraId;
    this.planejamentoId = data?.planejamentoId;
    this.questaoPlanejamentoId = data?.questaoPlanejamentoId;

    if (data?.osaExecucaoProgramaTrabalhoId) {
      this.model.osaExecucaoProgramaTrabalhoId = data.osaExecucaoProgramaTrabalhoId;
    }

    if (data?.questaoOrigem) {
      this.questaoOrigem = data.questaoOrigem;
      this.modoReuso = true;

      this.model.identificador = data.questaoOrigem.identificador;
      this.model.descricao = data.questaoOrigem.descricao;
      this.model.criterioAplicavel = data.questaoOrigem.criterioAplicavel;
      this.model.infRequerida = data.questaoOrigem.infRequerida;
      this.model.atividadeRelacionada = data.questaoOrigem.atividadeRelacionada;
      this.model.tipoTeste = data.questaoOrigem.tipoTeste;
      // amostraVinculadaId NÃO é copiada — o usuário escolhe a amostra da execução atual
    } else if (data?.identificador) {
      this.model.identificador = data.identificador;
    }

    if (data?.ordem) {
      this.model.ordem = data.ordem;
    }

    if (data?.element) {
      this.model = data.element;
      this.bloqueado = false;
    }

    //-> tela nova (id === 0): tudo bloqueado até o usuário decidir via lupa (Novo ou Selecionar Existente)
    if (!data?.element && this.id === 0) {
      this.bloqueado = true;
    }

  }

  ngOnInit(): void {
    this.carregarEnumTipoTeste();
    this.carregarAmostras();

    if (this.id)
      this.obter(this.id);
  }

  public carregarEnumTipoTeste() {
    this.tiposTesteQuestaoIncidental = Object.keys(this.enumTipoTesteQuestaoIncidental)
      .filter(key => !isNaN(Number(key)))
      .map(key => ({
        text: ETipoTesteQuestaoIncidentalDescricao[Number(key) as ETipoTesteQuestaoIncidental] ?? '',
        value: Number(key)
      }));
  }

  public abrirModalSelecionarQuestao() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-selecionar-questao-incidental";
    dialogConfig.width = "60vw";
    dialogConfig.maxHeight = "60vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      osaExecucaoProgramaTrabalhoId: this.model.osaExecucaoProgramaTrabalhoId
    };

    const modalSelecao = this.matDialog.open(OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoIncidSelecionarComponent, dialogConfig);

    modalSelecao.afterClosed().subscribe((resultado) => {
      if (!resultado) return; // Cancelar → mantém a tela como estava

      if (resultado.modo === 'nova') {
        //-> Regra 4: alerta + desbloqueia campos, exceto Identificador
        Swal.fire({
          icon: 'info',
          text: 'Uma nova questão incidental será gerada.',
          confirmButtonText: 'OK'
        }).then(() => {
          this.bloqueado = false;
          this.modoReuso = false;
          this.somenteLeituraReuso = false;
          this.questaoOrigemId = null;
          this.model.identificador = ''; // será preenchido automaticamente ao salvar
        });
      } else if (resultado.modo === 'existente') {
        //-> Crit 15 (HU reuso com edição): reaproveitar uma questão existente pré-preenche a tela
        //-> com os dados da origem, mas Técnicas, Riscos, Causas, Consequências, Controles,
        //-> Tipo dos Testes, Amostra Vinculada e Procedimentos permanecem editáveis.
        //-> Identificador/Descrição/Critérios/Fontes/Atividade seguem herdados (somente leitura).
        const questaoSelecionada = resultado.questao;

        if (questaoSelecionada?.id) {
          this.carregarQuestaoOrigemCompleta(questaoSelecionada.id);
        } else {
          this.preencherModelComQuestaoOrigem(questaoSelecionada);
        }
      }
    });
  }

  /**
   * Busca a questão de origem completa (com todas as coleções carregadas) antes de
   * popular o model, garantindo que riscos/causas/consequências/controles/técnicas/
   * procedimentos venham completos mesmo que o resultado do modal de seleção seja resumido.
   */
  private carregarQuestaoOrigemCompleta(questaoOrigemId: number) {
    this.osaExecucaoProgramaTrabalhoService
      .obterProgramaTrabalhoQuestaoPorId(questaoOrigemId)
      .then((res) => {
        if (res.sucesso) {
          this.preencherModelComQuestaoOrigem(res.dados);
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      })
      .catch((err) => {
        this.exibirMensagemAlerta(err.mensagem.descricao);
      });
  }

  private preencherModelComQuestaoOrigem(questao: IOsaExecucaoProgramaTrabalhoQuestaoModel) {
    this.modoReuso = true;
    this.questaoOrigemId = questao.id;
    this.bloqueado = false;
    //-> Crit 15: reuso permite edição dos 8 campos (não bloqueia mais)
    this.somenteLeituraReuso = false;

    //-> campos fixos, herdados da origem (somente leitura em tela)
    this.model.identificador = questao.identificador;
    this.model.descricao = questao.descricao;
    this.model.criterioAplicavel = questao.criterioAplicavel;
    this.model.infRequerida = questao.infRequerida;
    this.model.atividadeRelacionada = questao.atividadeRelacionada;
    this.model.tipoTeste = questao.tipoTeste;

    //-> coleções pré-preenchidas da origem, porém EDITÁVEIS (Ids zerados = novos registros na cópia)
    this.model.riscos = (questao.riscos ?? []).map(r => ({ ...r, id: 0, osaExecucaoProgramaTrabalhoQuestaoId: 0 }));
    this.model.causas = (questao.causas ?? []).map(c => ({ ...c, id: 0, osaExecucaoProgramaTrabalhoQuestaoId: 0 }));
    this.model.consequencias = (questao.consequencias ?? []).map(c => ({ ...c, id: 0, osaExecucaoProgramaTrabalhoQuestaoId: 0 }));
    this.model.controles = (questao.controles ?? []).map(c => ({ ...c, id: 0, osaExecucaoProgramaTrabalhoQuestaoId: 0 }));
    this.model.tecnicasAuditoria = (questao.tecnicasAuditoria ?? []).map(t => ({ ...t, id: 0, osaExecucaoProgramaTrabalhoQuestaoId: 0 }));
    this.model.procedimentos = (questao.procedimentos ?? []).map(p => ({ ...p, id: 0, osaExecucaoProgramaTrabalhoQuestaoId: 0 }));

    //-> atualiza as grades exibidas em tela
    this.dataSourceRisco.data = [...this.model.riscos];
    this.dataSourceCausa.data = [...this.model.causas];
    this.dataSourceConsequencia.data = [...this.model.consequencias];
    this.dataSourceControle.data = [...this.model.controles];
    this.dataSourceTecnicaAuditoria.data = [...this.model.tecnicasAuditoria];
    this.dataSourceProced.data = [...this.model.procedimentos];

    //-> amostraVinculadaId NÃO é copiada — o usuário escolhe a amostra da execução atual
    this.model.amostraVinculadaId = null;
  }

  carregarAmostras() {
    this.amostraService
      .obterAmostraPorPlanejamentoUnidadeGestora(this.planejamentoId, this.unidadeGestoraId)
      .then((res) => {
        this.amostras = res.dados as IAmostraModel[];
      })
      .catch((err) => {
        this.exibirMensagemAlerta(err.mensagem.descricao);
      });
  }

  private createModel(): IOsaExecucaoProgramaTrabalhoQuestaoModel {
    return {
      id: 0,
      osaExecucaoProgramaTrabalhoId: 0,
      questaoId: null,
      questao: {} as IQuestaoModel,
      tipo: 2,
      tipoDesc: 'Incidental',
      status: 0,
      statusDesc: 'Não Iniciada',
      avaliacao: null,
      avaliacaoDesc: '',
      observacao: null,
      responsavelId: null,
      responsavelNome: '',
      ordem: 0,
      identificador: '',
      evidencias: [],
      constatacoes: [],
      descricao: '',
      criterioAplicavel: '',
      infRequerida: '',
      atividadeRelacionada: '',
      tipoTeste: null,
      tipoTesteDesc: '',
      amostraVinculadaId: null,
      riscos: [],
      causas: [],
      consequencias: [],
      controles: [],
      procedimentos: [],
      tecnicasAuditoria: []
    };
  }

  public obter(id: number) {

    this.osaExecucaoProgramaTrabalhoService
      .obterProgramaTrabalhoQuestaoPorId(id)
      .then((res) => {
        if (res.sucesso) {
          this.model = res.dados;

          this.dataSourceRisco.data = this.model?.riscos;
          this.dataSourceRisco.paginator = this.tabelaRiscoPaginator;
          this.dataSourceRisco.sort = this.tabelaRiscoSort;
          this.dataSourceRisco.sortingDataAccessor = this.sortingDataAccessor;

          this.dataSourceCausa.data = this.model?.causas;
          this.dataSourceCausa.paginator = this.tabelaCausaPaginator;
          this.dataSourceCausa.sort = this.tabelaCausaSort;
          this.dataSourceCausa.sortingDataAccessor = this.sortingDataAccessor;

          this.dataSourceConsequencia.data = this.model?.consequencias;
          this.dataSourceConsequencia.paginator = this.tabelaConsequenciaPaginator;
          this.dataSourceConsequencia.sort = this.tabelaConsequenciaSort;
          this.dataSourceConsequencia.sortingDataAccessor = this.sortingDataAccessor;

          this.dataSourceControle.data = this.model?.controles;
          this.dataSourceControle.paginator = this.tabelaControlePaginator;
          this.dataSourceControle.sort = this.tabelaControleSort;
          this.dataSourceControle.sortingDataAccessor = this.sortingDataAccessor;

          this.dataSourceTecnicaAuditoria.data = this.model?.tecnicasAuditoria;
          this.dataSourceTecnicaAuditoria.paginator = this.tabelaTecnicaAuditoriaPaginator;
          this.dataSourceTecnicaAuditoria.sort = this.tabelaTecnicaAuditoriaSort;
          this.dataSourceTecnicaAuditoria.sortingDataAccessor = this.sortingTecnicaAuditoriaDataAccessor;

          this.dataSourceProced.data = this.model?.procedimentos;
          this.dataSourceProced.paginator = this.tabelaProcedPaginator;
          this.dataSourceProced.sort = this.tabelaProcedSort;
          this.dataSourceProced.sortingDataAccessor = this.sortingDataAccessor;

        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }


  public sortingDataAccessor = (item, property) => {
    switch (property) {
      case "descricao":
        return item.descricao;
      default:
        return item[property];
    }
  };

  public sortingTecnicaAuditoriaDataAccessor = (item, property) => {
    switch (property) {
      case "descricao":
        return item.tecnicaAuditoria.nome;
      default:
        return item[property];
    }
  };

  public addRiscoDigitado() {

    // Crit 15: reuso permite edição — sem bloqueio de somenteLeituraReuso

    if (this.riscoDigitado === "") {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Digite o Risco para incluir!",
      });
      return;
    }

    //-> antes de adicionar o procedimento de auditoria, verifica se ja existe
    const idx = this.model.riscos?.findIndex(x => x.descricao === this.riscoDigitado);
    if (idx !== undefined && idx > -1) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Risco já foi relacionado!",
      });
      return;
    }

    // adiciona na grade
    const novoRisco: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoModel = {
      id: 0,
      osaExecucaoProgramaTrabalhoQuestaoId: this.id,
      descricao: this.riscoDigitado
    };

    this.model.riscos.push(novoRisco);
    this.dataSourceRisco.data = [...this.model.riscos];
    this.riscoDigitado = "";
  }

  public excluirRisco(index: number) {

    // Crit 15: reuso permite edição — sem bloqueio de somenteLeituraReuso

    Swal.fire({
      title: "Excluir Risco?",
      text: "Confirma exclusão do Risco?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.isConfirmed) {
        this.model.riscos?.splice(index, 1);
        this.dataSourceRisco.data = [...this.model.riscos];
      }
    });
  }

  public addCausaDigitada() {

    // Crit 15: reuso permite edição — sem bloqueio de somenteLeituraReuso

    if (this.causaDigitada === "") {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Digite a Causa para incluir!",
      });
      return;
    }

    //-> antes de adicionar a causa, verifica se ja existe
    const idx = this.model.causas?.findIndex(x => x.descricao === this.causaDigitada);
    if (idx !== undefined && idx > -1) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Causa já foi relacionada!",
      });
      return;
    }

    // adiciona na grade
    const novaCausa: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalCausaModel = {
      id: 0,
      osaExecucaoProgramaTrabalhoQuestaoId: this.id,
      descricao: this.causaDigitada
    };

    this.model.causas.push(novaCausa);
    this.dataSourceCausa.data = [...this.model.causas];
    this.causaDigitada = "";
  }

  public excluirCausa(index: number) {

    // Crit 15: reuso permite edição — sem bloqueio de somenteLeituraReuso

    Swal.fire({
      title: "Excluir Causa?",
      text: "Confirma exclusão da Causa?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.isConfirmed) {
        this.model.causas?.splice(index, 1);
        this.dataSourceCausa.data = [...this.model.causas];
      }
    });
  }

  public addConsequenciaDigitada() {

    // Crit 15: reuso permite edição — sem bloqueio de somenteLeituraReuso

    if (this.consequenciaDigitada === "") {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Digite a Consequência para incluir!",
      });
      return;
    }

    //-> antes de adicionar a causa, verifica se ja existe
    const idx = this.model.consequencias?.findIndex(x => x.descricao === this.consequenciaDigitada);
    if (idx !== undefined && idx > -1) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Consequencia já foi relacionada!",
      });
      return;
    }

    // adiciona na grade
    const novaConsequencia: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalConsequenciaModel = {
      id: 0,
      osaExecucaoProgramaTrabalhoQuestaoId: this.id,
      descricao: this.consequenciaDigitada
    };

    this.model.consequencias.push(novaConsequencia);
    this.dataSourceConsequencia.data = [...this.model.consequencias];
    this.consequenciaDigitada = "";
  }

  public excluirConsequencia(index: number) {

    // Crit 15: reuso permite edição — sem bloqueio de somenteLeituraReuso

    Swal.fire({
      title: "Excluir Consequência?",
      text: "Confirma exclusão da Consequência?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.isConfirmed) {
        this.model.consequencias?.splice(index, 1);
        this.dataSourceConsequencia.data = [...this.model.consequencias];
      }
    });
  }

  public addControleDigitado() {

    // Crit 15: reuso permite edição — sem bloqueio de somenteLeituraReuso

    if (this.controleDigitado === "") {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Digite o Controle para incluir!",
      });
      return;
    }

    //-> antes de adicionar a causa, verifica se ja existe
    const idx = this.model.controles?.findIndex(x => x.descricao === this.controleDigitado);
    if (idx !== undefined && idx > -1) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Controle já foi relacionado!",
      });
      return;
    }

    // adiciona na grade
    const novoControle: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalControleModel = {
      id: 0,
      osaExecucaoProgramaTrabalhoQuestaoId: this.id,
      descricao: this.controleDigitado
    };

    this.model.controles.push(novoControle);
    this.dataSourceControle.data = [...this.model.controles];
    this.controleDigitado = "";
  }

  public excluirControle(index: number) {

    // Crit 15: reuso permite edição — sem bloqueio de somenteLeituraReuso

    Swal.fire({
      title: "Excluir Controle?",
      text: "Confirma exclusão do Controle?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.isConfirmed) {
        this.model.controles?.splice(index, 1);
        this.dataSourceControle.data = [...this.model.controles];
      }
    });
  }

  public async exibirModalTecnicaAuditoria() {

    // Crit 15: reuso permite edição — sem bloqueio de somenteLeituraReuso

    try {
      const res = await this.tecnicaAuditoriaService.obter("", true, true);
      if (res.sucesso) {

        var columns: { columnDef: string, header: string }[];

        columns = [
          {
            columnDef: 'id',
            header: 'Id'
          },
          {
            columnDef: 'nome',
            header: 'Nome'
          }
        ];

        const modal = this.exibirModal("Selecionar Técnica de Auditoria", res.dados, false, columns);
        modal.afterClosed().subscribe((data) => {
          if (data) {
            //=> carrega os dados do objeto que foi selecionado
            this.tecnicaAuditoriaSelecionada = data;
          }
        });
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    } catch (err) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        text: err.mensagem.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }

  public addTecnicaAuditoria() {

    // Crit 15: reuso permite edição — sem bloqueio de somenteLeituraReuso

    if (!this.tecnicaAuditoriaSelecionada.id) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Selecione a Técnica de Auditoria para incluir!",
      });
      return;
    }

    //-> antes de adicionar a técnica de auditoria, verifica se ja existe
    const idx = this.model.tecnicasAuditoria?.findIndex(x => x.tecnicaAuditoriaId === this.tecnicaAuditoriaSelecionada.id);
    if (idx !== undefined && idx > -1) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Técnica de Auditoria já foi relacionada!",
      });
      return;
    }

    // adiciona na grade
    const novaTecnicaAuditoria: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalTecnicaAuditoriaModel = {
      id: 0,
      osaExecucaoProgramaTrabalhoQuestaoId: this.id,
      tecnicaAuditoriaId: this.tecnicaAuditoriaSelecionada.id,
      tecnicaAuditoria: this.tecnicaAuditoriaSelecionada
    };

    this.model.tecnicasAuditoria.push(novaTecnicaAuditoria);
    this.dataSourceTecnicaAuditoria.data = [...this.model.tecnicasAuditoria];
    this.tecnicaAuditoriaSelecionada = {} as ITecnicaAuditoriaModel;
  }

  public excluirTecnicaAuditoria(index: number) {

    // Crit 15: reuso permite edição — sem bloqueio de somenteLeituraReuso

    Swal.fire({
      title: "Excluir Técnica de Auditoria ?",
      text: "Confirma exclusão da Técnica de Auditoria?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.isConfirmed) {
        this.model.tecnicasAuditoria?.splice(index, 1);
        this.dataSourceTecnicaAuditoria.data = [...this.model.tecnicasAuditoria];
      }
    });
  }

  public async exibirModalProcedimento() {

    // Crit 15: reuso permite edição — sem bloqueio de somenteLeituraReuso

    try {
      const res = await this.procedimentoAuditoriaService.obter("", true, true);
      if (res.sucesso) {

        var columns: { columnDef: string, header: string }[];

        columns = [
          {
            columnDef: 'id',
            header: 'Id'
          },
          {
            columnDef: 'nome',
            header: 'Nome'
          }
        ];

        const modal = this.exibirModal("Selecionar Procedimentos de Auditoria", res.dados, false, columns);
        modal.afterClosed().subscribe((data) => {
          if (data) {
            //=> carrega os dados do objeto que foi selecionado
            this.procedSelecionado = data;
          }
        });
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    } catch (err) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        text: err.mensagem.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }

  public addProcedimentoSelecionado() {

    // Crit 15: reuso permite edição — sem bloqueio de somenteLeituraReuso

    if (!this.procedSelecionado.id) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Selecione o Procedimento de Auditoria para incluir!",
      });
      return;
    }

    //-> antes de adicionar o procedimento de auditoria, verifica se ja existe
    const idx = this.model.procedimentos?.findIndex(x => x.descricao === this.procedSelecionado.nome);
    if (idx !== undefined && idx > -1) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Procedimento de Auditoria já foi relacionado!",
      });
      return;
    }

    // adiciona na grade
    const novoProcedimentoAuditoria: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalProcedModel = {
      id: 0,
      osaExecucaoProgramaTrabalhoQuestaoId: this.id,
      descricao: this.procedSelecionado.nome
    };

    this.model.procedimentos.push(novoProcedimentoAuditoria);
    this.dataSourceProced.data = [...this.model.procedimentos];
    this.procedSelecionado = {} as IProcedimentoAuditoriaModel;
  }

  public addProcedimentoDigitado() {

    // Crit 15: reuso permite edição — sem bloqueio de somenteLeituraReuso

    if (this.procedDigitado === "") {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Digite o Procedimento de Auditoria para incluir!",
      });
      return;
    }

    //-> antes de adicionar o procedimento de auditoria, verifica se ja existe
    const idx = this.model.procedimentos?.findIndex(x => x.descricao === this.procedDigitado);
    if (idx !== undefined && idx > -1) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Procedimento de Auditoria já foi relacionado!",
      });
      return;
    }

    // adiciona na grade
    const novoProcedimentoAuditoria: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalProcedModel = {
      id: 0,
      osaExecucaoProgramaTrabalhoQuestaoId: this.id,
      descricao: this.procedDigitado
    };

    this.model.procedimentos.push(novoProcedimentoAuditoria);
    this.dataSourceProced.data = [...this.model.procedimentos];
    this.procedDigitado = "";
  }

  public excluirProcedimento(index: number) {

    // Crit 15: reuso permite edição — sem bloqueio de somenteLeituraReuso

    Swal.fire({
      title: "Excluir Procedimento de Auditoria?",
      text: "Confirma exclusão do Procedimento de Auditoria?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.isConfirmed) {
        this.model.procedimentos?.splice(index, 1);
        this.dataSourceProced.data = [...this.model.procedimentos];
      }
    });
  }

  public salvar() {

    if (this.model.descricao === '') {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Descrição da Questão não informada!",
      });
      return;
    }

    if (this.model.criterioAplicavel === '') {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Critérios Aplicáveis não informado!",
      });
      return;
    }

    if (this.model.infRequerida === '') {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Informações Requeridas/Fontes não informada!",
      });
      return;
    }

    if (this.model.tecnicasAuditoria.length <= 0) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Técnicas de Auditoria não foram vinculadas!",
      });
      return;
    }

    if (this.model.atividadeRelacionada === '') {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Atividade Relacionada não informada!",
      });
      return;
    }

    if (this.model.riscos.length <= 0) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Riscos Associados não foram vinculados!",
      });
      return;
    }

    if (this.model.causas.length <= 0) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Causas não foram vinculadas!",
      });
      return;
    }

    if (this.model.consequencias.length <= 0) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Consequências não foram vinculadas!",
      });
      return;
    }

    if (!this.model.tipoTeste) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Tipo de Teste não Informado!",
      });
      return;
    }

    if (!this.model.amostraVinculadaId) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Amostra vinculada não Informada!",
      });
      return;
    }

    if (this.model.tipoTeste === 2 && this.model.controles.length <= 0) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Controles associados não foram vinculados!",
      });
      return;
    }

    if (this.model.procedimentos.length <= 0) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Procedimentos não foram vinculados!",
      });
      return;
    }

    if (this.bloqueado) {
      Swal.fire({
        toast: true, position: "top-end", showConfirmButton: false, timer: 5000,
        timerProgressBar: true, icon: "warning", text: "Utilize a lupa para escolher uma questão nova ou já existente!",
      });
      return;
    }

    if (!this.model.amostraVinculadaId) {
      Swal.fire({
        toast: true, position: "top-end", showConfirmButton: false, timer: 5000,
        timerProgressBar: true, icon: "warning", text: "Amostra vinculada não Informada!",
      });
      return;
    }
    if (this.id === 0) {
      this.model.status = 0;

      //-> Crit 15 / Regra 7.1.2 (reuso com edição): preserva o identificador da origem
      //-> (sem gerar novo), mas envia Tipo dos Testes + Amostra + as 6 coleções EDITADAS em tela
      //-> (Técnicas, Riscos, Causas, Consequências, Controles, Procedimentos).
      if (this.modoReuso && this.questaoOrigemId) {
        this.osaExecucaoProgramaTrabalhoService
          .inserirIncidentalExistente(
            this.questaoOrigemId,
            this.model.osaExecucaoProgramaTrabalhoId,
            this.model.amostraVinculadaId,
            this.model.tipoTeste,
            this.model.riscos,
            this.model.causas,
            this.model.consequencias,
            this.model.controles,
            this.model.tecnicasAuditoria,
            this.model.procedimentos
          )
          .then((res) => {
            if (res.sucesso) {

              this.dialogRef.close(true);

              Swal.fire({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                icon: "success",
                text: res.mensagem.descricao,
              });
            } else {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "warning",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            }
          });
      } else {
        //-> Regra 7.1.1: questão nova, gera identificador global
        this.osaExecucaoProgramaTrabalhoService
          .inserirProgramaTrabalhoQuestaoIncidental(this.model)
          .then((res) => {
            if (res.sucesso) {

              this.dialogRef.close(true);

              Swal.fire({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                icon: "success",
                text: res.mensagem.descricao,
              });
            } else {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "warning",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            }
          });
      }
    }
    else {
      this.osaExecucaoProgramaTrabalhoService
        .atualizarProgramaTrabalhoQuestaoIncidental(this.model)
        .then((res) => {
          if (res.sucesso) {

            this.dialogRef.close(true);

            Swal.fire({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              icon: "success",
              text: res.mensagem.descricao,
            });
          } else {
            Swal.fire({
              toast: true,
              position: "top-end",
              icon: "warning",
              text: res.mensagem.descricao,
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
            });
          }
        });
    }
  }

  public fechar() {
    this.dialogRef.close();
  }

  public cancelar() {
    Swal.fire({
      title: "Cancelar",
      text: "Todas as informações preenchidas serão perdidas. Deseja continuar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {
      if (res.value) {
        this.dialogRef.close();
      }
    });
  }
}